import create from "zustand";

// SIP credentials fetched once at dashboard boot and consumed by the
// webphone hooks. Kept in its own store rather than folded into userData so
// the webphone can subscribe to just this and not re-render on unrelated
// user updates (update_data refreshes userData on every updateData tick).
const useSipDataStore = create((set: any) => ({
    sipCredentials: null,
    setSipCredentials: (data: any) => set(() => ({ sipCredentials: data })),
}));

export { useSipDataStore };
